import { getCoachPremiumPage } from 'constants/pages';
import { useViewer } from 'hooks/useViewer';
import { ButtonLink } from 'components/Button';
import { formatCreationWithIntl } from 'components/Premium/utils';
import classNames from 'styles/utils/classNames';
import { SubscriptionTimeProps } from './props';

const SubscriptionTime: React.FC<SubscriptionTimeProps> = ({
  className,
  date,
  coachId,
  standalone = true,
  viewMoreCta = true,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col gap-10 p-ds-xl',
        standalone &&
          'border-color-border-input-lightmode-primary rounded-[24px] border shadow-[0_4px_16px_0_rgba(0,0,0,0.08)] dark:border-color-border-input-darkmode',
        className,
      )}
    >
      <div className="typography-product-heading-compact-desktop flex items-center justify-between gap-1">
        <span>Subscribed until</span>
        {date && <span>{formatCreationWithIntl(date, false)}</span>}
      </div>
      {viewMoreCta && (
        <ButtonLink href={getCoachPremiumPage(coachId)} size="lg" variant="brand">
          View Videos
        </ButtonLink>
      )}
    </div>
  );
};

export default SubscriptionTime;
